// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2YClD","productName":"Table_productName__cYiwJ"};